
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`இது
                    <a href="${0}">ஃபோக்சோனமி எஞ்சின் திட்டத்தால் கொண்டு வரப்படுகிறது</a>. பங்கேற்கவோ அல்லது கருத்து தெரிவிக்கவோ தயங்காதீர்கள்
                    .`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`இந்தக் கருவி மூலப்பொருட்கள் பட்டியலைச் சரிசெய்ய உங்களை அனுமதிக்கிறது. நீங்கள்
                மூலப்பொருட்கள் பட்டியலைச் சேர்க்கலாம், நீக்கலாம் அல்லது திருத்தலாம்.
                <br>
                இந்த எழுத்து <span class="highlight">␣</span> ஒரு இடத்தைக் குறிக்கிறது.
                <br>
                இந்த எழுத்து <span class="highlight">↩︎</span> ஒரு வரி முறிவைக் குறிக்கிறது. `,
'hb28f1f2ec1744ee9': html`இந்தப் பண்புகள் பயனர்களால் எந்த வகையான பயன்பாடுகளுக்காகவும் உருவாக்கப்பட்டு தாக்கல் செய்யப்படுகின்றன.
                    உங்கள் சொந்தத்தைச் சேர்க்க தயங்க வேண்டாம். நீங்கள் உருவாக்கும் பண்புகள் மற்றும் மதிப்புகள்
                    <strong>உண்மையாக இருக்க வேண்டும்</strong>. நீங்கள்
                    <a href="${0}">சமூகத்தால் ஏற்கனவே பயன்படுத்தப்பட்ட பண்புகளின் பட்டியலில்</a>
                    க்குள் செல்லலாம் அல்லது
                    <a href="${1}">பண்புகளின் ஆவணங்கள் மற்றும் அதன் தேடுபொறி</a>ஐ ஆராயலாம்.`,
's000a5b76bd3a01c2': `பண்புகளை ஏற்றுகிறது...`,
's000d98595e959c1e': `Google Play இல் பெறவும்`,
's013bdc8cf0d3583d': `தேவையான பொருட்களுக்கு எங்களுக்கு உதவுங்கள்.`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `செதுக்கலைச் சரிபார்க்கவும்`,
's03e9c8114521b998': `நான் தேவையான பொருட்களை திருத்துவேன்.`,
's05ec315d9308091a': `பார்கோடு மூலைகள் ஐகான்`,
's061eb5af92512c85': `சேமிக்கப்பட்டது! வேறு ஏதாவது உதவி செய்ய முடியுமா?`,
's06847c221c4c0bc1': `[உங்கள் பயன்பாட்டு வழக்கை விவரிக்க] ஒரு சொத்தை உருவாக்க விரும்புகிறேன்...`,
's06f6c6f99db6b552': `அசல்`,
's081e2ad82db71e1d': `தொகுக்கப்பட்ட மதிப்புகள்`,
's09205907b5b56cda': `இல்லை`,
's0b4235aae602a950': `பிரத்யேக ஆவணங்கள்`,
's0bb2d48532acc455': `CSV பதிவிறக்கவும்`,
's0d5b7fee0311db68': `சொத்து`,
's0fb218abc2e157ed': `படத்தை செல்லாததாக்கு`,
's100c4928cc74642a': `பொது சுகாதார ஆராய்ச்சியின் முன்னேற்றத்தை ஆதரிக்கவும்.`,
's10db5498186c083b': `செதுக்குவதை ரத்துசெய்`,
's11a18a69b30b65ed': `பொருட்கள் பட்டியலில் உள்ள பிழைகளை சரிசெய்ய எங்களுக்கு உதவுங்கள்.`,
's1205d5f6fccf8e69': `சொத்து மதிப்பு`,
's15d64a0a6715285a': `புதிய சாவி`,
's166bd56d19670a72': `பெரிதாக்கு`,
's19059bf0c4f7c162': `தேர்வுப் பகுதி`,
's1a52515ec8ddade8': `தயாரிப்பு பார்கோடு`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `ஊட்டச்சத்து தகவல்களை சரிசெய்ய எங்களுக்கு உதவுங்கள்.`,
's1e00019dc454872d': `property-name பண்புக்கூறைப் பயன்படுத்தி ஒரு சொத்து பெயரை வழங்கவும்.`,
's1e49126af0935a5b': `இந்தப் பண்பைப் பயன்படுத்தும் தயாரிப்புகளின் பட்டியல்`,
's21e73088de6f26f3': `Download on the App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Cancel`,
's2db7b654c0a9bde0': `சொத்தை ஆவணப்படுத்தவும்`,
's300b3a6ee4e1252d': str`மோசமான பொருத்தம் ${0}%`,
's33f786bb6b4f0cf4': `பயிர் முடிவு`,
's33f85f24c0f5f008': `சேமி`,
's34be4af4e8fec4ae': `முதலில் சமூகத்திடம் கேளுங்கள்.`,
's36d86adc823cbfa6': `ஒரு புதிய சொத்தை உருவாக்கும் முன், அதைப் பற்றி சமூகத்துடன் விவாதிக்கவும்:`,
's3781d25aa51a736c': `ஃபோக்சோனமி எஞ்சின் ஆவணங்கள்`,
's383ae4449428b61e': `செதுக்கு மீட்டமை`,
's39bcf88721a1e8ee': `தேர்வை மீட்டமை`,
's39e14e14300694c7': `ஆவணங்கள் மற்றும் வழிகாட்டுதல்கள்`,
's3b430cfa5c1fe7f4': str`${0}க்கான ஆவணங்கள்`,
's3f4e4b52f230a892': `பட கேன்வாஸ்`,
's417b90913e05bc17': `முன்னோட்டம்`,
's41f7dca46d3f1b4a': `Value`,
's422bba9636ce2489': `மையப் படம்`,
's42dd66b2441566fd': `மைய ஐகான்`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `ஒரு ஊட்டச்சத்தைச் சேர்க்கவும்.`,
's453ab0dbb9b5c777': `வலதுபுறம் அளவை மாற்று`,
's475b08749d0706ed': `உலகெங்கிலும் உள்ள மில்லியன் கணக்கான நுகர்வோருக்கு அவர்கள் என்ன சாப்பிடுகிறார்கள் என்பதைப் பற்றித் தெரிவிக்க எங்களுக்கு உதவுங்கள்`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `தயாரிப்பு எண்ணிக்கை`,
's4df2f533c0c1e7d0': `படக் கட்டுப்பாடுகள்`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `தேர்வை நகர்த்து`,
's4f751fb9b3ed766c': `ஒரு புதிய சொத்தை உருவாக்குதல்`,
's547c12ae169d00bc': `F-Droid இல் கிடைக்கிறது`,
's5560fb119e40923d': `சொத்து பெயரை உள்ளிடவும்...`,
's55d7249883a98ca1': `இந்த சொத்து பற்றி திறந்த உணவு உண்மைகள் விக்கியில்`,
's565867d84c04aea2': `வடிகட்டி பண்புகள்...`,
's5666afe5cd0166de': `உறுதிப்படுத்துவதற்கு முன் பிழைகளைச் சரிசெய்யவும் அல்லது உரையை மாற்றவும்.`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `தயாரிப்புகளை ஏற்றுகிறது...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `ஊட்டச்சத்து தகவல்களை சரிசெய்ய எங்களுக்கு உதவுங்கள்.`,
's5dd6f12783fca34f': `பொருட்கள் பட்டியலைத் திருத்து`,
's5e8250fb85d64c23': `மூடுக‌`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `நான் ஆதரிக்கிறேன்`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `திருத்து`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `உங்கள் பங்களிப்புக்கு நன்றி!`,
's6cee7cad81dfedd1': `செதுக்கப்பட்ட படம்`,
's6d7b6cdedaadfb6e': `ஒவ்வொரு நன்கொடையும் கணக்கிடப்படுகிறது! உலகில் மேலும் உணவு வெளிப்படைத்தன்மையை கொண்டு வர உங்கள் ஆதரவை நாங்கள் பாராட்டுகிறோம்.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`நல்ல பொருத்தம் ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `ஆவணப்படுத்தல்`,
's787dd11bed0dc88a': `இடதுபுற அளவை மாற்று`,
's7ce4fd9430e80cea': `value`,
's801a05fa8e881f37': `சொத்து உருவாக்கம் மற்றும் வழிகாட்டுதல்கள் பற்றி மேலும் அறிக:`,
's8038273de2cf8b73': `செதுக்க ஒரு பகுதியைத் தேர்ந்தெடுக்கவும்.`,
's839cc2908a5387f2': `பார்கோடுகளை வடிகட்டவும்...`,
's86197dcf3e96af64': `இருக்கும் பண்புகளை உலாவவும் தேடவும்`,
's8a63be30a129a59c': `கீழ்ப்பகுதியின் அளவை மாற்று`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `மேல் வலதுபுற அளவை மாற்று`,
's8db84aa4bc949af2': `புதிய சொத்தை ஆவணப்படுத்தவும்`,
's8f839a03997a16d7': `தயாரிப்பைக் காண்க`,
's901ae1e236ac45d3': `நீக்குதலை ரத்துசெய்`,
's907f7a97c6b29425': `தரவு மாதிரி மாற்றியமைக்கப்படலாம் என்பதை நினைவில் கொள்ளுங்கள். உங்கள் சொந்த ஆபத்தில் பயன்படுத்தவும்.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `தேவையான பொருட்கள்:`,
's9a7f60fce090ecaf': `பண்புகளை ஏற்ற முடியவில்லை. பிறகு முயற்சிக்கவும்.`,
's9b87abd68fb9df45': `கிடைக்கவில்லையா? புதிய சாவியை உருவாக்கு {value}`,
's9c0f52425fd2f07e': `பொருந்தாமல் போகலாம்`,
's9fc41f789c63b40d': `தயாரிப்புகள்`,
'sa1fa766e0d5634d7': `மதிப்பெண் கிடைக்கவில்லை.`,
'sa548778b24054030': `ஃபோக்சோனமி எஞ்சின் திட்டத்திலிருந்து பங்களிக்கப்பட்ட அனைத்து சொத்துக்களையும் ஆராயுங்கள். இந்த பண்புகள் கூடுதல் மெட்டாடேட்டா மற்றும் திறந்த உணவு உண்மைகள் தரவுத்தளத்தில் உள்ள தயாரிப்புகள் பற்றிய நுண்ணறிவுகளை வழங்குகின்றன.`,
'sa63907958bd0ec4b': `மேல் இடதுபுற அளவை மாற்று`,
'sa95b4224f685a36a': `மாதிரியை மூடு`,
'sab56a1d439576fd6': `பரிந்துரை ஐகான்`,
'sac47ea2901d04c15': `கீழ் இடதுபுற அளவை மாற்று`,
'sb125227d436c2925': `ஏற்கனவே உள்ள பண்புகள் தரவுத்தளத்தில் உங்கள் சொத்து கருத்தைத் தேடுங்கள்:`,
'sb125568d43642e6f': `தயாரிப்பு பற்றிய கேள்விகளுக்கு பதிலளிக்கவும்.`,
'sb1c538e038f9b214': str`மிகச் சிறந்த பொருத்தம் ${0}%`,
'sb28639570ff3b852': `அனைத்து சொத்துக்களின் பட்டியல்`,
'sb3bdd638a58d30f4': `அர்ப்பணிப்புள்ள குடிமக்கள் சமூகத்தில் ஈடுபட,`,
'sb3cbcc1bd0fff140': `உங்கள் சொத்து இல்லை என்பதை நீங்கள் சரிபார்த்து, சமூகம் அது பயனுள்ளதாக இருப்பதை ஒப்புக்கொண்டவுடன், முதலில் அதை விக்கியில் ஆவணப்படுத்த வேண்டும்.`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `இந்த சொத்துக்கு எந்த தயாரிப்புகளும் கிடைக்கவில்லை.`,
'sb7f72e4c8a2d3357': `வடிகட்டி மதிப்புகள்...`,
'sb8178320160f84ea': `செதுக்குதலைக் காட்டு`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `எல்லா நுண்ணறிவுகளுக்கும் பதில் கிடைத்துவிட்டது! உங்கள் உதவிக்கு நன்றி!`,
'sbd9a0b2293b3cd3c': `பரிமாறும் அளவு`,
'sbe472dc3c2685985': `தொடர்புடைய மதிப்பு`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `மேல் அளவை மாற்று`,
'sc1c08d0cbcc3bd24': `பொருந்தவில்லை`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `பரிந்துரைக்கப்பட்ட திருத்தம்`,
'sc681b137e8f604f7': `Confirm deletion`,
'sc6daf8a31883f8b9': `படத்தை நகர்த்து`,
'sc895972c88d38ca5': `நாட்டுப்புறவியல் சொத்து`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `வரிசைகள்`,
'scb3b0671d7b7f640': `புதிய மதிப்பு`,
'scb489a1a173ac3f0': `ஆம்`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `ஸ்லாக் கலந்துரையாடலில் சேருங்கள்`,
'scdb6cad0b92721bf': `எந்த சொத்துக்களும் கிடைக்கவில்லை.`,
'scf23a05631f93732': `நீக்குவதை உறுதிப்படுத்தவும்`,
'scfed2f270ef6a3aa': `பகுதியைத் தேர்ந்தெடுக்கவும்`,
'sd1022bc1ef9204f7': `பெரிதாக்கக்கூடிய படம்`,
'sd1077c055cf9ba6b': `தயாரிப்பின் மூலப்பொருள் பட்டியலை சரிபார்க்க எங்களுக்கு உதவுங்கள்.`,
'sd698d21ddecba56b': `ஹேய்! பின்வரும் பகுதிகளுக்கு பதிலளிப்பதன் மூலம் தயாரிப்பு தகவலை மேம்படுத்த எங்களுக்கு உதவலாம்:`,
'sd82bc2decefa621b': `உணவுத் தொழிலில் இருந்து சுதந்திரமாக இருத்தல்,`,
'sdb97e5976482606e': `ஒரு சொத்து ஏற்கனவே உள்ளதா எனச் சரிபார்க்கவும்.`,
'sdbf806fefc584115': `நீங்கள் ஒரு கண்டுபிடிக்க வேண்டும்`,
'sdc673e73b5c13aea': `நீக்கு`,
'sdc792b75f1edcaba': `மூலப்பொருட்களின் எழுத்துப்பிழைகளைச் சரிசெய்ய எங்களுக்கு உதவுங்கள்.`,
'sdca5deead576ceee': `கீழ் வலதுபுற அளவை மாற்று`,
'sdcc2555c5dde524f': `இந்த உருப்படியை நீக்க விரும்புகிறீர்களா? இந்த செயலை செயல்தவிர்க்க முடியாது.`,
'se206feec7ec57b28': `100 கிராமுக்கு`,
'se419a9ab36987490': `செல்லாததாக்கு`,
'se5127cf0f92e7e48': `குறிப்பு: நீங்கள் இவற்றையும் காணலாம்`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `நான் ஒரு நல்ல பயிரை முன்மொழிகிறேன்.`,
'seea3800e27baa686': `தனிப்பட்ட தயாரிப்புகள்`,
'sefaba4adc4ec9219': `ஃபோக்சோனமி பண்புகள்`,
'seffa8ca49175b5f0': `தனிப்பயனாக்கப்பட்ட பண்புகள்`,
'sf44a6b3b232c28ea': str`தற்போதைய மதிப்பை ${0}ஆல் மாற்றவும்.`,
'sf4cd86a2f5ef2588': `தயாரிப்பு பார்கோடு`,
'sf57a61152168cc81': `மூலப்பொருள் கண்டறிதலை சரிசெய்ய எங்களுக்கு உதவுங்கள்.`,
'sf88b90b8ba23871c': `தெரியாத பொருத்தம்`,
'sf9aee319a006c9b4': `சேர்`,
'sfacbbe968fa7d773': `சொத்து பெயர்:`,
'sfc40ea3d5d5aa6f8': `எங்கள் இலாப நோக்கற்ற சங்கத்தின் அன்றாட நடவடிக்கைகளுக்கு உங்கள் நன்கொடைகள் நிதியளிக்கின்றன:`,
'sfe87465d50530725': `தொடர்புடைய மதிப்பு`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  